import { render, staticRenderFns } from "./HomeSanitizer.vue?vue&type=template&id=88e4d0d8&scoped=true&"
import script from "./HomeSanitizer.vue?vue&type=script&lang=js&"
export * from "./HomeSanitizer.vue?vue&type=script&lang=js&"
import style0 from "./HomeSanitizer.vue?vue&type=style&index=0&id=88e4d0d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e4d0d8",
  null
  
)

export default component.exports